<template>
  <img
    v-bind="$attrs"
    :alt="alt"
    :src="src"
    :class="$style.image"
    :style="style.image"
  />
</template>

<script setup lang="ts">
import { createStyle } from '@v1/composables/create-style';
import { StyleExtender } from '@v1/composables/style-extender';

const styleExtender = new StyleExtender(
  { variablePrefix: '--v1-base-image', extraPropertyNames: ['filter'] },
);

const props = defineProps({
  alt: {
    type: String,
    required: false,
    default: '',
  },
  aspectRatio: {
    type: [Number, String],
    required: false,
    default: 'auto',
  },
  objectFit: {
    type: String,
    required: false,
    default: 'cover',
  },
  src: {
    type: [Object, String],
    required: false,
    default: '//:0',
  },
  styleExtension: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  asReactive: {
    type: Boolean,
    required: false,
    default: false,
  },
});

// data
const style = createStyle({
  image: {
    aspectRatio: props.aspectRatio,
    objectFit: props.objectFit,
  },
}, {
  asReactive: props.asReactive,
});

styleExtender.extend({
  target: style.image,
  extension: props.styleExtension.image,
  selector: 'image',
});
</script>

<style module lang="scss">
.image {
  background-color: var(--v1-base-image-image-background-color);
  border: var(--v1-base-image-image-border);
  border-radius: var(--v1-base-image-image-border-radius);
  border-width: var(--v1-base-image-image-border-width);
  box-shadow: var(--v1-base-image-image-box-shadow);
  cursor: var(--v1-base-image-image-cursor);
  filter: var(--v1-base-image-image-filter);

  &:hover {
    background-color: var(--v1-base-image-image-background-color-hover);
    border: var(--v1-base-image-image-border-hover);
    border-radius: var(--v1-base-image-image-border-radius-hover);
    border-width: var(--v1-base-image-image-border-width-hover);
    box-shadow: var(--v1-base-image-image-box-shadow-hover);
    cursor: var(--v1-base-image-image-cursor-hover);
    filter: var(--v1-base-image-image-filter-hover);
  }

  &:active {
    background-color: var(--v1-base-image-image-background-color-active);
    border: var(--v1-base-image-image-border-active);
    border-radius: var(--v1-base-image-image-border-radius-active);
    border-width: var(--v1-base-image-image-border-width-active);
    box-shadow: var(--v1-base-image-image-box-shadow-active);
    cursor: var(--v1-base-image-image-cursor-active);
    filter: var(--v1-base-image-image-filter-active);
  }
}
</style>
